module.exports = __webpack_public_path__ + "img/kontakt_cjo.6a9d56b1.png";